import styled from "styled-components";
import { motion } from "framer-motion";
import { Link } from "react-router-dom"; //
const CTASection = styled.section`
  padding: 100px 0;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  position: relative;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    width: 500px;
    height: 500px;
    background: radial-gradient(
      circle,
      rgba(255, 215, 0, 0.1) 0%,
      transparent 70%
    );
    top: -250px;
    right: -250px;
    border-radius: 50%;
  }
`;

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
  position: relative;
  z-index: 1;
`;

const CTATitle = styled(motion.h2)`
  font-family: "Playfair Display", serif;
  font-size: clamp(2.5rem, 5vw, 4rem);
  color: #ffffff;
  margin-bottom: 1.5rem;
`;

const CTASubtitle = styled(motion.p)`
  font-size: 1.3rem;
  color: #b0b0b0;
  margin-bottom: 3rem;
  line-height: 1.8;
`;

const CTAButton = styled(motion.button)`
  padding: 1.2rem 3.5rem;
  font-size: 1.2rem;
  font-weight: 600;
  background: linear-gradient(135deg, #ffd700 0%, #ffa500 100%);
  color: #0a0a0a;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(255, 215, 0, 0.3);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 40px rgba(255, 215, 0, 0.4);
  }
`;

const CTA = () => {
  return (
    <CTASection>
      <Container>
        <CTATitle
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Ready to Master a New Language?
        </CTATitle>
        <CTASubtitle
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          Join thousands of successful learners who chose the luxury path to
          fluency
        </CTASubtitle>
        <Link to="/payment" style={{ textDecoration: "none" }}>
          <CTAButton
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Start Your Free Trial
          </CTAButton>
        </Link>
      </Container>
    </CTASection>
  );
};

export default CTA;
